import type { Handler } from './handler';
import type { ApiFetchCategoryGamesPort } from './ports/api-fetch-category-games.port';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchCategoryGamesHandler: Handler<Params, Ports, Result> = async (
  params,
  ports = {
    apiFetchCategoryGames: resolveAdapter('apiFetchCategoryGames'),
  },
) => {
  const [category, fetchError] = await tryCatch(
    ports?.apiFetchCategoryGames.handle(params.slug),
  );

  if (fetchError) {
    console.error(
      `[fetchCategoryGamesHandler] Erro ao buscar categoria "${params.slug}":`,
      fetchError,
    );

    return { category: null };
  }

  return { category };
};

type Params = { slug: string };

type Ports = {
  apiFetchCategoryGames: ApiFetchCategoryGamesPort;
};

type Result = Promise<{ category: HomeCategoryData | null }>;
